import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { SignInDialogComponent } from './sign-in';

import { reducer } from './store/auth.reducer';
import { AuthenticationEffects } from './store/auth.effects';
import { LoginComponent } from '../login/login.component';
import { SharedModule } from '../shared/shared.module';
import { PinDialogComponent } from './pin-dialog/pin-dialog.component';
import { CompanyAccessDialogComponent } from './company-access-dialog/company-access-dialog.component';
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature('auth', reducer),
        EffectsModule.forFeature([AuthenticationEffects])
    ],
    declarations: [LoginComponent, SignInDialogComponent, PinDialogComponent, CompanyAccessDialogComponent]
})
export class AuthModule {}
